import { ReactNode } from "react";

type Props = {
  label: string;
  children: ReactNode;
};

export default function CreateEntityRow({ label, children }: Props) {
  return (
    <div className="w-full flex flex-col gap-3">
      <div className="text-15 text-white/50 font-bold">{label}</div>
      {children}
    </div>
  );
}
